import React from "react";
import type { PopupType } from "../types";
import { Sonometer } from "sonometer/types/sonometer.model";
import { config } from "config";

interface TextPopupProps {
  type: Extract<PopupType, "texte1" | "texte2" | "texte3">;
  sonometer?: Sonometer;
}

export const { assetBaseUrl } = config;

const TextPopup: React.FC<TextPopupProps> = ({ type, sonometer }) => {
  const getContent = () => {
    // Hardcoding gifUrl for demonstration based on user instruction

    switch (type) {
      case "texte1":
        return {
          text:
            sonometer?.publicScreenSettings.welcomeMessage ||
            "Vous êtes prêts à exploser <br>le record de décibels ?", // Reverted to user's requested text
          fontSize: "60px",
          gifUrl:
            sonometer?.publicScreenSettings.welcomeGif ||
            assetBaseUrl + "/images/konan_louder.gif", // Set to specific GIF
        };
      case "texte2":
        return {
          text:
            sonometer?.publicScreenSettings.teaserMessage ||
            "FAITES UN MAXIMUM DE BRUIIIIIIT !",
          fontSize: "56px",
          gifUrl: sonometer?.publicScreenSettings.teaserGif, // Set to specific GIF
        };
      case "texte3":
        return {
          text:
            sonometer?.publicScreenSettings.endMessage ||
            "MERCI A TOUS !<br> BON MATCH !",
          fontSize: "56px",
          gifUrl:
            sonometer?.publicScreenSettings.endGif ||
            assetBaseUrl + "/images/team_hello.gif", // Set to specific GIF
        };
      default:
        return { text: "", fontSize: "2rem", gifUrl: undefined };
    }
  };

  const { text, fontSize, gifUrl } = getContent();

  return (
    <div className="w-[1540px] h-[220px] overflow-hidden font-virage">
      <div className="flex h-full">
        {/* Left Sponsor - Same as RankingPopup */}
        <div className="w-[260px] h-[220px] flex items-center justify-center">
          <img
            src={
              sonometer?.publicScreenSettings.sponsorLogo ||
              assetBaseUrl + "/images/sponsor_left.png"
            }
            alt="Sponsor"
            className="max-w-full max-h-full"
          />
        </div>

        {/* Margin - Same as RankingPopup */}
        <div className="w-[250px]"></div>

        {/* Text Content Area - Replaces ranking section */}
        <div className="flex-1 flex items-center justify-center">
          <div
            className="text-center leading-tight"
            style={{ fontSize: fontSize }}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        </div>

        {/* Right Section - Conditional GIF display with Tailwind CSS for specified styling */}
        <div className="w-[410px] h-[220px] flex items-center justify-center">
          {gifUrl && (
            <div className="w-[300px] flex justify-end">
              {" "}
              {/* Tailwind classes for width and justify-end */}
              <img
                src={gifUrl}
                width="200px"
                alt="Animated GIF"
                className="max-w-full max-h-full object-contain"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TextPopup;
